import React from 'react';
import Home from './pages/Home';


const App = () => {
  return (
    <main>
      <Home/>
      <footer style={{
              position: 'absolute',
              bottom: '0%',
              left: '5%',
              paddingBottom: '1rem',
              fontSize: '1.5rem',
          }}>
      </footer>
    </main>
  );
};

export default App;
